import { CPNA_BASE_URL } from "../../props";
import { useGet, doPost, usePut } from "../../common/fetchServices";
import { last, pickBy, pipe, split } from "ramda";
import { notBlank } from "../../util/ext";
import querystring from "querystring";
import { formatDateString } from "../../util/stringFormat";

const LIMIT = 25;

const getStopJobExecUrl = ({ executionId }) =>
  `${CPNA_BASE_URL}/workflow/processing/execution/${executionId}/status/aborted`;

export const useDiscoverySearch = ({
  startDate,
  endDate,
  contentProviderId,
  contentProviderEndpointId,
  filter,
  order,
  page,
  limit = LIMIT,
}) => {
  const params = pickBy((val, _key) => notBlank(val), {
    startDate: formatDateString(startDate),
    endDate: formatDateString(endDate),
    contentProvider: contentProviderId,
    contentProviderEndpoint: contentProviderEndpointId,
    fileLocation: filter,
    sort: order,
    page,
    size: limit,
  });
  const queryParams = querystring.encode(params);
  const url = `${CPNA_BASE_URL}/api/manage/report/discovery?${queryParams}`;
  return useGet(["discovery", { url }], url);
};

export const useParsedMetadataForJob = (jobId, page = 0, limit = 10) => {
  const queryParams = querystring.encode({ page, size: limit });

  const url = `${CPNA_BASE_URL}/api/manage/report/parsed/${jobId}?${queryParams}`;
  return useGet(["parsed-metadata", { url }], url);
};

export const useJobErrors = (
  jobId,
  eventType,
  appliedFilter,
  page = 0,
  limit = 10,
) => {
  const params = pickBy((val, _key) => notBlank(val), {
    eventType: eventType,
    mediaId: appliedFilter,
    page,
    size: limit,
  });
  const queryParams = querystring.encode(params);

  const url = `${CPNA_BASE_URL}/api/manage/report/errors/${jobId}?${queryParams}`;
  return useGet(["job-errors", { url }], url);
};

export const useMediaErrors = (jobId, mediaId, page = 0, limit = 10) => {
  const queryParams = querystring.encode({ page, size: limit });

  const url = `${CPNA_BASE_URL}/api/manage/report/errors/${jobId}/media/${mediaId}?${queryParams}`;
  return useGet(["media-errors", { url }], url);
};

export const useMetadataDiscoveryEvent = jobId => {
  const url = `${CPNA_BASE_URL}/events/metadata-discovery/${jobId}`;
  return useGet(["metadata-discovery-event", { jobId }], url);
};

export const useContentMetadataParseEvent = (jobId, mediaId) => {
  const url = `${CPNA_BASE_URL}/events/content-metadata-parse/${jobId}/${mediaId}`;
  return useGet(["content-metadata-parse", { jobId, mediaId }], url);
};

export const useContentProviders = () => {
  const url = `${CPNA_BASE_URL}/rip/content-provider`;
  return useGet("content-providers", url);
};

export const useContentProviderEndpoints = () => {
  const url = `${CPNA_BASE_URL}/rip/content-provider-endpoint`;
  return useGet("content-provider-endpoints", url);
};

export const useJobExecutionDetails = executionId => {
  const url = `${CPNA_BASE_URL}/workflow/processing/execution/${executionId}`;
  return useGet(["job-execution-details", { executionId }], url);
};

export const useStopJobExecution = () => {
  return usePut(getStopJobExecUrl, {
    queriesToInvalidate: ["job-execution-details", ["executionId"]],
  });
};

export const getDownloadUrl = async (auth, location) => {
  const url = `${CPNA_BASE_URL}/api/manage/files/download/s3`;
  const downloadUrl = await doPost(auth)(url, { location });
  console.log(downloadUrl);
  return downloadUrl.url;
};

export const generateFilename = pipe(split("/"), last);
